/* eslint-disable no-unused-vars */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { cacheActions } from '@redux/slices/cache';

function RegisterLocation() {
  const dispatch = useDispatch();

  const distanceUnit = useSelector((state) => state.settings.settings?.['distanceUnit']);
  const proximityIndicatorMap = { miles: 'mi', kilometers: 'km' };
  const unit = proximityIndicatorMap[distanceUnit] || '';

  useEffect(() => {
    if (unit && dispatch) dispatch?.(cacheActions.setNewUnit({ unit }));
  }, [unit, dispatch]);

  return null;
}

RegisterLocation.propTypes = {};

export default RegisterLocation;
